<template>
	<div class="container">
		<div class="col-md-12">
			<h2> {{ labels.title }} </h2>
		</div>
		<b-container>
			<!-- Filtros principales - Centrados -->
			<b-row class="mb-4 justify-content-center mt-5">
				<!-- Reporte -->
				<b-col md="4">
					<label class="d-block fw-bold" style="font-size: 1.3rem;"><b>Cod.Reporte:</b></label>
					<select v-model="dialogReportes" class="form-control form-control-lg" @change="f_carga_informacion">
						<option value="">{{ labels.select }}</option>
						<option v-for="(item, idx) in reportes" :key="'codigo-' + idx" :value="item.codigo">
							{{ item.codigo }}-{{ item.nombre }}
						</option>
					</select>
				</b-col>

				<!-- Vigencia -->
				<b-col md="4">
					<label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.validity }}</b></label>
					<select v-model="selVigencia" class="form-control form-control-lg" @change="f_carga_informacion">
						<option value="">{{ labels.select }}</option>
						<option v-for="vigencia in listVigencia" :key="vigencia.vigencia">
							{{ vigencia.vigencia }}
						</option>
					</select>
				</b-col>

				<!-- Compañía (condicional) -->
				<b-col md="4" v-if="showSelCompany">
					<label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.company }}</b></label>
					<select v-model="selCompany" class="form-control form-control-lg" @change="f_carga_informacion">
						<option value="">{{ labels.select }}</option>
						<option v-for="company in listCompany" :value="company.id" :key="company.id">
							{{ company.nombre }}
						</option>
					</select>
				</b-col>
			</b-row>
		</b-container>
		<div class="row col-md-12 mt-2" v-if="selVigencia && selCompany">
			<div class="row col-md-12 justify-content-center">
				<md-table md-card md-fixed-header v-model="listaNotas">
					<md-table-row slot="md-table-row" slot-scope="{ item }"
						@click="showDialog = false; showNotaDetalle = false; showParrafo = false; showCuentas = false; showNiif = false">
						<md-table-cell :md-label="labels.numero" class="border">{{ item.numero }}</md-table-cell>
						<md-table-cell :md-label="labels.nota" class="text-left border">{{ item.descripcion
						}}</md-table-cell>
						<md-table-cell :md-label="labels.definicion" class="border">
							<md-button style="background-color: #2e507a; width: 30px; height: 30px;"
								class="md-fab md-primary"
								@click.stop="showNota(item.id, item.numero, item.descripcion)">
								<md-icon>list</md-icon>
							</md-button>
						</md-table-cell>
						<md-table-cell :md-label="labels.edit" class="border">
							<md-button style="background-color: #e5ac00; width: 30px; height: 30px;"
								class="md-fab md-primary" @click="editNota(item.id)">
								<md-icon>edit</md-icon>
							</md-button>
						</md-table-cell>
						<md-table-cell :md-label="labels.delete" class="border">
							<md-button style="background-color: #cd2838; width: 30px; height: 30px;"
								class="md-fab md-primary" @click="deleteNota(item.id, item.numero)">
								<md-icon>delete</md-icon>
							</md-button>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
		</div>
		<b-container v-if="showNotaDetalle">
			<md-dialog-content>
				<md-table v-model="a_detalle" md-card md-fixed-header @md-selected="f_actualiza_nota">
					<md-table-toolbar>
						<h1 class="md-title"><b><i>{{ f_titulo() }}</i></b> &nbsp;&nbsp; &nbsp;&nbsp;
							&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
						</h1>
						<md-button style="background-color: #2e507a; width: 30px; height: 30px;"
							class="md-fab md-primary" @click="f_nuevo_parrafo">
							<md-icon>add</md-icon>
						</md-button>
					</md-table-toolbar>
					<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
						<md-table-cell :md-label="labels.parrafo" class="text-left border">{{ item.parrafo
						}}</md-table-cell>
						<md-table-cell :md-label="labels.tipo" class="text-left border">{{ item.tipo }}</md-table-cell>
						<md-table-cell :md-label="labels.titulo" class="text-left border">{{ item.titulo
						}}</md-table-cell>
						<md-table-cell :md-label="labels.orden" class="text-left border">{{ item.orden
						}}</md-table-cell>
					</md-table-row>
				</md-table>
				<md-dialog-actions>
					<md-button class="md-accent" @click="cerrarNotaDetalle()">{{ labels.close }}</md-button>
				</md-dialog-actions>
			</md-dialog-content>
		</b-container>
		<b-container v-if="showDialog || showParrafo" class="pb-5">
			<b-row><b-col cols="6" class="text-left border">
					<h4><b><i>{{ labels.parrafo }}</i></b></h4>
				</b-col>
				<b-col v-if="showDialog" cols="6" class="text-left border">
					<h4><b><i>{{ formParrafo.parrafo }}</i></b></h4>
				</b-col>
				<b-col v-if="showParrafo" cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.parrafo" class="text-left border" size="60"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>

			<b-row><b-col cols="6" class="text-left border">
					<h4><b><i>{{ labels.tipo }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="text-left border">
					<h4><b><i>
								<select v-model="formParrafo.tipo" @change="f_actualiza_forma">
									<option value="TFG">Texto Fijo General</option>
									<option value="TFC">Texto Fijo Compañia</option>
									<option value="TVG">Texto Variable General</option>
									<option value="TVC">Texto Variable Compañia</option>
									<option value="TBA">Tabla Contable Saldo Actual</option>
									<option value="TBT">Tabla Contable Saldo Anterior</option>
									<option value="TBC">Tabla Contable Comparativa</option>
									<option value="TBM">Tabla Manual</option>
									<option value="TNA">Tabla Niif Notas Saldo Actual</option>
									<option value="TNT">Tabla Niif Notas Saldo Anterior</option>
									<option value="TNC">Tabla Niif Notas Comparativa</option>
								</select>
							</i></b></h4>
				</b-col>
			</b-row>

			<b-row><b-col cols="6" class="text-left border">
					<h4><b><i>{{ labels.parrafo_titulo }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.titulo" class="text-left border" size="60"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row><b-col v-if="showTexto" cols="12" class="text-left border">
					<h4><b><i>{{ labels.parrafo_texto }}</i></b></h4>
				</b-col>
			</b-row>
			<b-row><b-col v-if="showTexto" cols="12" class="border">
					<!-- NUEVO EDITOR RICO -->
					<RichTextEditor ref="textEditor" v-model="formParrafo.texto_html" :height="400"
						:placeholder="labels.editor_placeholder" @input="f_cambia_texto_html"
						@change="f_cambia_texto_html" />
					<!-- Mantener campo oculto para texto plano (backward compatibility) -->
					<input type="hidden" v-model="formParrafo.texto" />
				</b-col>
			</b-row>

			<b-row><b-col v-if="showCampo" cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.campo0 }}</i></b></h4>
				</b-col>
				<b-col v-if="showCampo" cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.valor_campo0" type="text" size="60"
								@change="f_cambia_campo(0)" maxlength="20"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row><b-col v-if="showCampo" cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.campo1 }}</i></b></h4>
				</b-col>
				<b-col v-if="showCampo" cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.valor_campo1" type="text" size="60"
								@change="f_cambia_campo(1)" maxlength="20"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row><b-col v-if="showCampo" cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.campo2 }}</i></b></h4>
				</b-col>
				<b-col v-if="showCampo" cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.valor_campo2" type="text" size="60"
								@change="f_cambia_campo(2)" maxlength="20"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row><b-col v-if="showCampo" cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.campo3 }}</i></b></h4>
				</b-col>
				<b-col v-if="showCampo" cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.valor_campo3" type="text" size="60"
								@change="f_cambia_campo(3)" maxlength="20"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row><b-col v-if="showCampo" cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.campo4 }}</i></b></h4>
				</b-col>
				<b-col v-if="showCampo" cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.valor_campo4" type="text" size="60"
								@change="f_cambia_campo(4)" maxlength="20"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row><b-col v-if="showCampo" cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.campo5 }}</i></b></h4>
				</b-col>
				<b-col v-if="showCampo" cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.valor_campo5" type="text" size="60"
								@change="f_cambia_campo(5)" maxlength="20"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row><b-col v-if="showCampo" cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.campo6 }}</i></b></h4>
				</b-col>
				<b-col v-if="showCampo" cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.valor_campo6" type="text" size="60"
								@change="f_cambia_campo(6)" maxlength="20"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row><b-col v-if="showCampo" cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.campo7 }}</i></b></h4>
				</b-col>
				<b-col v-if="showCampo" cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.valor_campo7" type="text" size="60"
								@change="f_cambia_campo(7)" maxlength="20"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row><b-col v-if="showCampo" cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.campo8 }}</i></b></h4>
				</b-col>
				<b-col v-if="showCampo" cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.valor_campo8" type="text" size="60"
								@change="f_cambia_campo(8)" maxlength="20"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row><b-col v-if="showCampo" cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.campo9 }}</i></b></h4>
				</b-col>
				<b-col v-if="showCampo" cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.valor_campo9" type="text" size="60"
								@change="f_cambia_campo(9)" maxlength="20"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row><b-col v-if="showCampoTabla" cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.nroFilas }}</i></b></h4>
				</b-col>
				<b-col v-if="showCampoTabla" cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.numeroFilas" type="text" size="60"
								@change="f_filas"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row><b-col v-if="showCampoTabla" cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.nroColumnas }}</i></b></h4>
				</b-col>
				<b-col v-if="showCampoTabla" cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.numeroColumnas" type="text" size="60"
								@change="f_columnas"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showFila0"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.filas[0].d_fila }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.filas[0].descripcion" type="text" size="60"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showFila1"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.filas[1].d_fila }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.filas[1].descripcion" type="text" size="60"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showFila2"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.filas[2].d_fila }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.filas[2].descripcion" type="text" size="60"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showFila3"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.filas[3].d_fila }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.filas[3].descripcion" type="text" size="60"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showFila4"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.filas[4].d_fila }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.filas[4].descripcion" type="text" size="60"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showFila5"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.filas[5].d_fila }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.filas[5].descripcion" type="text" size="60"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showFila6"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.filas[6].d_fila }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.filas[6].descripcion" type="text" size="60"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showFila7"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.filas[7].d_fila }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.filas[7].descripcion" type="text" size="60"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showFila8"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.filas[8].d_fila }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.filas[8].descripcion" type="text" size="60"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showFila9"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.filas[9].d_fila }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.filas[9].descripcion" type="text" size="60"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>

			<b-row v-if="showColumna0"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.columnas[0].d_columna }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.columnas[0].descripcion" type="text" size="60"></md-input>
						</h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showColumna1"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.columnas[1].d_columna }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.columnas[1].descripcion" type="text" size="60"></md-input>
						</h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showColumna2"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.columnas[2].d_columna }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.columnas[2].descripcion" type="text" size="60"></md-input>
						</h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showColumna3"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.columnas[3].d_columna }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.columnas[3].descripcion" type="text" size="60"></md-input>
						</h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showColumna4"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.columnas[4].d_columna }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.columnas[4].descripcion" type="text" size="60"></md-input>
						</h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showColumna5"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.columnas[5].d_columna }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.columnas[5].descripcion" type="text" size="60"></md-input>
						</h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showColumna6"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.columnas[6].d_columna }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.columnas[6].descripcion" type="text" size="60"></md-input>
						</h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showColumna7"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.columnas[7].d_columna }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.columnas[7].descripcion" type="text" size="60"></md-input>
						</h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showColumna8"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.columnas[8].d_columna }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.columnas[8].descripcion" type="text" size="60"></md-input>
						</h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showColumna9"><b-col cols="6" class="text-left border">
					<h4><b><i> {{ formParrafo.columnas[9].d_columna }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formParrafo.columnas[9].descripcion" type="text" size="60"></md-input>
						</h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row v-if="showNiif">
				<b-col cols="6" class="text-left border">
					<h4><b><i>NIIF</i></b></h4>
				</b-col>
				<b-col cols="6" class="text-left border">
					<!-- Campo de búsqueda para NIIF -->
					<div class="mb-3">
						<input type="text" v-model="niifSearchTerm" @input="filterNiifList" placeholder="Buscar NIIF..."
							class="form-control" style="width: 100%;" />
					</div>

					<!-- Contenedor scrollable con checkboxes -->
					<div style="height: 200px; overflow-y: auto; border: 1px solid #ccc; padding: 10px;">
						<!-- Opción para seleccionar todos -->
						<div class="mb-2" style="border-bottom: 1px solid #eee; padding-bottom: 5px;">
							<label style="cursor: pointer; font-weight: bold;">
								<input type="checkbox" v-model="selectAllNiif" @change="toggleSelectAllNiif"
									style="margin-right: 8px;" />
								Seleccionar todos los NIIF filtrados
							</label>
						</div>

						<!-- Lista de NIIF con checkboxes -->
						<div v-for="niif in filteredNiifList" :key="niif.niif" class="mb-2">
							<label style="cursor: pointer; display: flex; align-items: center;">
								<input type="checkbox" :value="niif.niif" v-model="formParrafo.niif"
									style="margin-right: 8px;" />
								<span style="font-size: 14px;">
									<strong>{{ niif.niif }}</strong> - {{ niif.nameNiif }}
								</span>
							</label>
						</div>

						<!-- Mensaje si no hay resultados -->
						<div v-if="filteredNiifList.length === 0" class="text-center text-muted mt-3">
							No se encontraron NIIF
						</div>
					</div>

					<!-- Información de selección -->
					<div class="mt-3">
						<div style="font-size: 12px; color: #666; margin-bottom: 5px;">
							<strong>{{ formParrafo.niif.length }}</strong> NIIF(s) seleccionado(s)
						</div>
					</div>
				</b-col>
			</b-row>
			<b-row v-if="showCuentas">
				<b-col class="text-left border">
					<h4><b><i>CUENTA</i></b></h4>
				</b-col>
				<b-col class="text-left border">
					<!-- Campo de búsqueda -->
					<div class="mb-3">
						<input type="text" v-model="cuentasSearchTerm" @input="filterCuentasList"
							placeholder="Buscar cuentas..." class="form-control" style="width: 100%;" />
					</div>

					<!-- Contenedor scrollable con checkboxes -->
					<div style="height: 200px; overflow-y: auto; border: 1px solid #ccc; padding: 10px;">
						<!-- Opción para seleccionar todas -->
						<div class="mb-2" style="border-bottom: 1px solid #eee; padding-bottom: 5px;">
							<label style="cursor: pointer; font-weight: bold;">
								<input type="checkbox" v-model="selectAllCuentas" @change="toggleSelectAllCuentas"
									style="margin-right: 8px;" />
								Seleccionar todas las cuentas filtradas
							</label>
						</div>

						<!-- Lista de cuentas con checkboxes -->
						<div v-for="cuenta in filteredCuentasList" :key="cuenta.cuenta" class="mb-2">
							<label style="cursor: pointer; display: flex; align-items: center;">
								<input type="checkbox" :value="cuenta.cuenta" v-model="formParrafo.cuentas"
									style="margin-right: 8px;" />
								<span style="font-size: 14px;">
									<strong>{{ cuenta.cuenta }}</strong> - {{ cuenta.descripcion }}
								</span>
							</label>
						</div>

						<!-- Mensaje si no hay resultados -->
						<div v-if="filteredCuentasList.length === 0" class="text-center text-muted mt-3">
							No se encontraron cuentas
						</div>
					</div>

					<!-- Información de selección -->
					<div class="mt-3">
						<div style="font-size: 12px; color: #666; margin-bottom: 5px;">
							<strong>{{ formParrafo.cuentas.length }}</strong> cuenta(s) seleccionada(s)
						</div>
						<div style="font-size: 11px; color: #888;">
							{{ labels.selectAccounts }}
						</div>
					</div>
				</b-col>
			</b-row>

			<md-button v-if="!showParrafo" class="md-accent" @click="elimineParrafo()">
				<h4><b>Eliminar</b></h4>
			</md-button>
			<md-button v-if="showParrafo" class="md-primary" @click="creaParrafo()">
				<h4><b>Crear</b></h4>
			</md-button>
			<md-button v-if="!showParrafo" class="md-primary" @click="modificaParrafo()">
				<h4><b>Modificar</b></h4>
			</md-button>
			<md-button class="md-secundary" @click="cerrarDialogParrafo()">
				<h4><b>Cerrar</b></h4>
			</md-button>
		</b-container>
		<b-container v-if="showNuevo || showEdita" class="pb-5">

			<b-row><b-col cols="6" class="text-left border">
					<h4><b><i>{{ labels.numero }}</i></b></h4>
				</b-col>
				<b-col v-if="showEdita" cols="6" class="text-left border">
					<h4><b><i>{{ formNueva.numero }}</i></b></h4>
				</b-col>
				<b-col v-if="showNuevo" cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formNueva.numero" class="text-left border" size="60"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>
			<b-row><b-col cols="6" class="text-left border">
					<h4><b><i>{{ labels.nota }}</i></b></h4>
				</b-col>
				<b-col cols="6" class="border">
					<md-field>
						<h4><md-input v-model="formNueva.descripcion" type="text" size="60"></md-input></h4>
					</md-field>
				</b-col>
			</b-row>

			<md-button v-if="showNuevo" class="md-primary" @click="grabeNota()">
				<h4><b>Crear</b></h4>
			</md-button>
			<md-button v-if="showEdita" class="md-primary" @click="actualizaNota()">
				<h4><b>Modifica</b></h4>
			</md-button>
			<md-button class="md-accent" @click="showNuevo = false; showEdita = false">
				<h4><b>Cerrar</b></h4>
			</md-button>
		</b-container>
	</div>
</template>

<script>
import Notas from '../../../services/Notas';
import PlanCuentas from '../../../services/PlanCuentas';
import Company from '../../../services/Company'
import Balance from '../../../services/BalanceNiif'
import PlanConsolidacion from '../../../services/PlanConsolidacion'
import RichTextEditor from '@/components/RichTextEditor.vue'

export default {
	name: 'Notas',
	data: () => ({
		isLoading: false,
		cuentasSearchTerm: '',
		filteredCuentasList: [],
		niifSearchTerm: '',
		filteredNiifList: [],
		selectAllNiif: false,
		selectAllCuentas: false,
		selVigencia: '',
		selReporte: '',
		reportes: [],
		cachedNotaData: null,
		dialogReportes: '',
		components: {
			RichTextEditor,
		},
		listVigencia: [],
		currentNotaId: null,
		formParrafo: {
			id: null,
			numero: null,
			parrafo: null,
			tipo: null,
			titulo: '',
			texto: '',
			texto_html: '',
			numeroFilas: '',
			numeroColumnas: '',
			filas: [],
			columnas: [],
			cuentas: [],
			niif: []
		},
		showTblNotas: false,
		listaNotas: [],
		modCreaNota: false,
		modEditaNota: false,
		infoNota: [],
		infoVigComp: {},
		deletFila: false,
		showSelCompany: false,
		selCompany: '',
		listCompany: [],
		listCuentas: [],
		listNiif: [],
		fgl_detalle: false,
		numero: false,
		showNotaDetalle: false,
		showDialog: false,
		showParrafo: false,
		showCampo: false,
		showCampoTabla: false,
		showTexto: false,
		showCuentas: false,
		showNiif: false,

		nota: "",
		a_detalle: [],
		a_detalle_columnas: [],
		a_detalle_cuentas: [],
		a_detalle_niif: [],
		a_detalle_filas: [],
		a_detalle_tabla: [],
		a_detalle_texto: [],
		a_informacion_tblm: [],
		a_informacion_txfc: [],
		a_informacion_txfg: [],
		a_informacion_txvc: [],
		a_informacion_txvg: [],

		showFila0: false,
		showFila1: false,
		showFila2: false,
		showFila3: false,
		showFila4: false,
		showFila5: false,
		showFila6: false,
		showFila7: false,
		showFila8: false,
		showFila9: false,
		showColumna0: false,
		showColumna1: false,
		showColumna2: false,
		showColumna3: false,
		showColumna4: false,
		showColumna5: false,
		showColumna6: false,
		showColumna7: false,
		showColumna8: false,
		showColumna9: false,

		formNueva: {
			numero: '',
			descripcion: '',
		},
		showNuevo: false,
		showEdita: false,
	}),
	computed: {
		labels() {
			if (this.$store.state._language == "es-ES") {
				return {
					title: 'Notas',
					validity: 'Vigencia:',
					select: 'Seleccione...',
					numero: 'Número',
					nota: 'Nota',
					descripcion: 'Descripcion',
					definicion: 'Definicion',
					cuenta: 'Cuenta',
					description: 'Descripción',
					edit: 'Editar',
					delete: 'Eliminar',
					company: 'Compañia:',
					parrafo: "Parrafo",
					parrafo_titulo: "Titulo",
					parrafo_texto: "Texto",
					tipo: "Tipo",
					titulo: "Titulo",
					orden: "Orden",
					close: "Cerrar",
					editor_placeholder: "Escribe el contenido aquí... Puedes usar negrita, cursiva, listas, etc.",
					selectAccounts: "Seleccionar Cuentas",
					accountsSelected: "cuentas seleccionadas",
					noAccountsSelected: "No hay cuentas seleccionadas"
				}
			} else {
				return {
					title: 'Notes',
					validity: 'Validity',
					select: 'Select...',
					numero: 'Number',
					nota: 'Note',
					descripcion: 'Description',
					definicion: 'Definition',
					cuenta: 'Account',
					description: 'Description',
					edit: 'Edit',
					delete: 'Delete',
					company: 'Company',
					parrafo: "Paragraph",
					parrafo_titulo: "Title",
					parrafo_texto: "Text",
					tipo: "Class",
					titulo: "Title",
					orden: "Order",
					close: "Close",
					editor_placeholder: "Escribe el contenido aquí... Puedes usar negrita, cursiva, listas, etc.",
					selectAccounts: "Select Accounts",
					accountsSelected: "accounts selected",
					noAccountsSelected: "No accounts selected"

				}
			}
		}
	},
	methods: {
		f_muestre_fila(fila) {
			this.showFila0 = false
			this.showFila1 = false
			this.showFila2 = false
			this.showFila3 = false
			this.showFila4 = false
			this.showFila5 = false
			this.showFila6 = false
			this.showFila7 = false
			this.showFila8 = false
			this.showFila9 = false

			if (this.formParrafo.numeroFilas > fila) {
				switch (fila) {
					case 0: {
						this.showFila0 = true
						break
					}
					case 1: {
						this.showFila0 = true
						this.showFila1 = true
						break
					}
					case 2: {
						this.showFila0 = true
						this.showFila1 = true
						this.showFila2 = true
						break
					}
					case 3: {
						this.showFila0 = true
						this.showFila1 = true
						this.showFila2 = true
						this.showFila3 = true
						break
					}
					case 4: {
						this.showFila0 = true
						this.showFila1 = true
						this.showFila2 = true
						this.showFila3 = true
						this.showFila4 = true
						break
					}
					case 5: {
						this.showFila0 = true
						this.showFila1 = true
						this.showFila2 = true
						this.showFila3 = true
						this.showFila4 = true
						this.showFila5 = true
						break
					}
					case 6: {
						this.showFila0 = true
						this.showFila1 = true
						this.showFila2 = true
						this.showFila3 = true
						this.showFila4 = true
						this.showFila5 = true
						this.showFila6 = true
						break
					}
					case 7: {
						this.showFila0 = true
						this.showFila1 = true
						this.showFila2 = true
						this.showFila3 = true
						this.showFila4 = true
						this.showFila5 = true
						this.showFila6 = true
						this.showFila7 = true
						break
					}
					case 8: {
						this.showFila0 = true
						this.showFila1 = true
						this.showFila2 = true
						this.showFila3 = true
						this.showFila4 = true
						this.showFila5 = true
						this.showFila6 = true
						this.showFila7 = true
						this.showFila8 = true
						break
					}
					case 9: {
						this.showFila0 = true
						this.showFila1 = true
						this.showFila2 = true
						this.showFila3 = true
						this.showFila4 = true
						this.showFila5 = true
						this.showFila6 = true
						this.showFila7 = true
						this.showFila8 = true
						this.showFila9 = true
						break
					}
				}
			}
		},

		getCuentaDisplay(cuentaId) {
			const cuenta = this.listCuentas.find(c => c.cuenta == cuentaId);
			return cuenta ? `${cuenta.cuenta} - ${cuenta.descripcion}` : cuentaId;
		},

		removeCuenta(cuentaId) {
			const index = this.formParrafo.cuentas.indexOf(cuentaId);
			if (index > -1) {
				this.formParrafo.cuentas.splice(index, 1);
			}
		},
		f_muestre_columna(columna) {
			this.showColumna0 = false
			this.showColumna1 = false
			this.showColumna2 = false
			this.showColumna3 = false
			this.showColumna4 = false
			this.showColumna5 = false
			this.showColumna6 = false
			this.showColumna7 = false
			this.showColumna8 = false
			this.showColumna9 = false

			if (this.formParrafo.numeroColumnas > columna) {
				switch (columna) {
					case 0: {
						this.showColumna0 = true
						break
					}
					case 1: {
						this.showColumna0 = true
						this.showColumna1 = true
						break
					}
					case 2: {
						this.showColumna0 = true
						this.showColumna1 = true
						this.showColumna2 = true
						break
					}
					case 3: {
						this.showColumna0 = true
						this.showColumna1 = true
						this.showColumna2 = true
						this.showColumna3 = true
						break
					}
					case 4: {
						this.showColumna0 = true
						this.showColumna1 = true
						this.showColumna2 = true
						this.showColumna3 = true
						this.showColumna4 = true
						break
					}
					case 5: {
						this.showColumna0 = true
						this.showColumna1 = true
						this.showColumna2 = true
						this.showColumna3 = true
						this.showColumna4 = true
						this.showColumna5 = true
						break
					}
					case 6: {
						this.showColumna0 = true
						this.showColumna1 = true
						this.showColumna2 = true
						this.showColumna3 = true
						this.showColumna4 = true
						this.showColumna5 = true
						this.showColumna6 = true
						break
					}
					case 7: {
						this.showColumna0 = true
						this.showColumna1 = true
						this.showColumna2 = true
						this.showColumna3 = true
						this.showColumna4 = true
						this.showColumna5 = true
						this.showColumna6 = true
						this.showColumna7 = true
						break
					}
					case 8: {
						this.showColumna0 = true
						this.showColumna1 = true
						this.showColumna2 = true
						this.showColumna3 = true
						this.showColumna4 = true
						this.showColumna5 = true
						this.showColumna6 = true
						this.showColumna7 = true
						this.showColumna8 = true
						break
					}
					case 9: {
						this.showColumna0 = true
						this.showColumna1 = true
						this.showColumna2 = true
						this.showColumna3 = true
						this.showColumna4 = true
						this.showColumna5 = true
						this.showColumna6 = true
						this.showColumna7 = true
						this.showColumna8 = true
						this.showColumna9 = true
						break
					}
				}
			}
		},
		f_filas() {
			let a_filas = []
			let vd_fila = {
				id: 0,
				numero: this.numero,
				parrafo: this.formParrafo.parrafo,
				vigencia: this.selVigencia,
				fila: '',
				d_fila: '',
				descripcion: "",
			}
			const numeroFilas = parseInt(this.formParrafo.numeroFilas)
			for (let i = 1; i <= numeroFilas; i++) {
				vd_fila.d_fila = "Fila " + i
				vd_fila.descripcion = ""
				vd_fila.fila = i
				const df = this.a_detalle_filas.find((fila) => fila.fila == i)
				if (df) {
					vd_fila.descripcion = df.descripcion
				}
				a_filas.push({ fila: vd_fila.fila, d_fila: vd_fila.d_fila, descripcion: vd_fila.descripcion })
			}
			this.formParrafo.filas = a_filas
			this.f_muestre_fila(numeroFilas - 1)
		},
		f_columnas() {
			let a_columnas = []
			let vd_columna = {
				id: 0,
				numero: this.numero,
				parrafo: this.formParrafo.parrafo,
				vigencia: this.selVigencia,
				columna: '',
				d_columna: '',
				descripcion: "",
			}
			const numeroColumnas = parseInt(this.formParrafo.numeroColumnas)
			for (let i = 1; i <= numeroColumnas; i++) {
				vd_columna.d_columna = "Columna " + i
				vd_columna.descripcion = ""
				vd_columna.columna = i
				if (this.a_detalle_columnas) {
					const dc = this.a_detalle_columnas.find((columna) => columna.columna == i)
					if (dc) {
						vd_columna.descripcion = dc.descripcion
					}
				}
				a_columnas.push({ columna: vd_columna.columna, d_columna: vd_columna.d_columna, descripcion: vd_columna.descripcion })
			}
			this.formParrafo.columnas = a_columnas
			this.f_muestre_columna(numeroColumnas - 1)
		},
		// En el método f_pide_campo(), asegurar que cuentas se inicialice
		f_pide_campo() {
			this.showTexto = false;
			this.showCampo = false;
			this.showCampoTabla = false;
			this.showCuentas = false;
			this.showNiif = false;

			// Limpiar el editor si no es necesario
			if (this.$refs.textEditor && !['TFG', 'TFC', 'TVG', 'TVC'].includes(this.formParrafo.tipo)) {
				if (this.$refs.textEditor.clear) {
					this.$refs.textEditor.clear();
				}
			}

			if (this.formParrafo.tipo == "TFG" || this.formParrafo.tipo == "TFC") {
				this.showTexto = true;
				this.showCampo = false;
			}
			if (this.formParrafo.tipo == "TVG" || this.formParrafo.tipo == "TVC") {
				this.showTexto = true;
				this.showCampo = false;
			}
			if (this.formParrafo.tipo == "TBM") {
				this.showCampoTabla = true;
			}
			if (this.formParrafo.tipo == "TNA" || this.formParrafo.tipo == "TNT" || this.formParrafo.tipo == "TNC") {
				if (!Array.isArray(this.formParrafo.niif)) {
					this.formParrafo.niif = [];
				}
				this.showNiif = true;

				this.$nextTick(() => {
					this.filterNiifList();
				});
			}
			if (this.formParrafo.tipo == "TBA" || this.formParrafo.tipo == "TBT" || this.formParrafo.tipo == "TBC") {
				// Inicializar cuentas como array vacío si no existe
				if (!Array.isArray(this.formParrafo.cuentas)) {
					this.formParrafo.cuentas = [];
				}
				this.showCuentas = true;

				// Asegurar que la lista filtrada esté actualizada
				this.$nextTick(() => {
					this.filterCuentasList();
				});
			}
		},
		actualizaTbl() {
			Notas.getAllNotas()
				.then((res) => {
					this.listaNotas = res.data.listNotas
					this.modCreaNota = false
					this.modEditaNota = false
				})
				.catch((err) => {
					console.log(err)
				})
				.finally(() => {
					this.isLoading = false;
				})
		},
		async editNota(id) {
			const ed = this.listaNotas.find((nota) => nota.id = id)
			this.formNueva.id = id
			this.formNueva.numero = ed.numero
			this.formNueva.descripcion = ed.descripcion
			this.showEdita = true
		},
		deleteNota(id, numero) {

			Notas.deleteNota(id, this.dialogReportes,numero)
				.then((res) => {
					this.$toast.success(res.data.message)
					this.actualizaTbl()
				})
				.catch(() => console.log("Error al borrar Nota"))
		},
		async showNota(id, numero, nota) {
			// 1. Resetear estados
			this.showDialog = false;
			this.showParrafo = false;
			this.showNotaDetalle = false;

			// 2. Guardar datos básicos
			this.nota = nota;
			this.numero = numero;
			this.currentNotaId = id;

			try {
				const result = await Balance.getNotas(
					this.dialogReportes,  // ← Código ORIGINAL aquí (50)
					this.selCompany,
					this.selVigencia,
					numero
				);

				// 5. Guardar los datos (mantener compatibilidad)
				this.a_detalle = result.data.a_detalle;
				this.a_detalle_texto = result.data.a_detalle_texto;
				this.a_informacion_txfg = result.data.a_informacion_txfg;
				this.a_informacion_txfc = result.data.a_informacion_txfc;
				this.a_informacion_txvg = result.data.a_informacion_txvg;
				this.a_informacion_txvc = result.data.a_informacion_txvc;
				this.a_informacion_tblm = result.data.a_informacion_tblm;

				// 5.1. Cargar datos adicionales si existen
				this.a_detalle_cuentas = result.data.a_detalle_cuentas || [];
				this.a_detalle_niif = result.data.a_detalle_niif || [];
				this.a_detalle_filas = result.data.a_detalle_filas || [];
				this.a_detalle_columnas = result.data.a_detalle_columnas || [];

				console.log('Datos cargados:', {
					cuentas: this.a_detalle_cuentas.length,
					niif: this.a_detalle_niif.length,
					filas: this.a_detalle_filas.length,
					columnas: this.a_detalle_columnas.length,
					tablas: this.a_detalle_tabla.length
				});

				// 6. Mostrar el detalle
				this.showNotaDetalle = true;

			} catch (error) {
				console.error('Error al cargar nota:', error);
				this.$toast.error("Error al cargar los detalles de la nota");
			}
		},
		f_titulo() {
			let titulo = ""
			if (this.$store.state._language == "es-ES") {
				titulo = "NOTAS ESTADOS FINANCIEROS"
			} else {
				titulo = "FINANCIAL STATEMENT NOTES"
			}
			titulo = titulo + " " + this.nota
			return titulo

		},
		f_nueva_nota() {
			this.formNueva.numero = ''
			this.formNueva.descripcion = ''
			this.showNuevo = true
			this.showParrafo = false
			this.showDialog = false;
			this.showNotaDetalle = false;
			this.showCuentas = false;
			this.showNiif = false;
		},
		f_nuevo_parrafo() {
			// Inicializar completamente el objeto formParrafo
			this.formParrafo = {
				id: null,
				numero: null,
				parrafo: '',
				tipo: '',
				titulo: '',
				orden: '',
				texto: '',
				texto_html: '',

				// Campos específicos para TVG/TVC
				valor_campo0: '',
				valor_campo1: '',
				valor_campo2: '',
				valor_campo3: '',
				valor_campo4: '',
				valor_campo5: '',
				valor_campo6: '',
				valor_campo7: '',
				valor_campo8: '',
				valor_campo9: '',

				// Etiquetas de los campos (para mostrar en la UI)
				campo0: 'Campo 0',
				campo1: 'Campo 1',
				campo2: 'Campo 2',
				campo3: 'Campo 3',
				campo4: 'Campo 4',
				campo5: 'Campo 5',
				campo6: 'Campo 6',
				campo7: 'Campo 7',
				campo8: 'Campo 8',
				campo9: 'Campo 9',

				// Para tablas manuales
				numeroFilas: '',
				numeroColumnas: '',
				nroFilas: '',
				nroColumnas: '',
				filas: [],
				columnas: [],

				// Para selecciones múltiples
				cuentas: [],
				niif: []
			};

			this.showParrafo = true;
			this.showDialog = false;
			this.showNotaDetalle = false;

			// LIMPIAR TODOS LOS FLAGS DE VISUALIZACIÓN
			this.showCuentas = false;
			this.showNiif = false;
			this.showTexto = false;
			this.showCampo = false;
			this.showCampoTabla = false;

			this.formAnterior = { ...this.formParrafo };

		},
		creaParrafo() {
			// 1. Validaciones básicas
			if (this.formParrafo.parrafo == '') {
				this.$toast.error("Campo(s) pendiente(s) por diligenciar");
				return;
			}
			if (this.formParrafo.tipo == '') {
				this.$toast.error("Campo(s) pendiente(s) por diligenciar");
				return;
			}
/*			if (this.formParrafo.titulo == '') {
				this.$toast.error("Campo(s) pendiente(s) por diligenciar");
				return;
			}
*/

			// 2. Validaciones específicas según tipo
			if (['TFG', 'TFC', 'TVG', 'TVC'].includes(this.formParrafo.tipo)) {
				let texto_plano = '';
				if (this.$refs.textEditor && this.$refs.textEditor.getText) {
					texto_plano = this.$refs.textEditor.getText();
				}

				if (!texto_plano || texto_plano.trim() === '') {
					this.$toast.error("El texto no puede estar vacío para este tipo de párrafo");
					return;
				}
			}

			// Validación para cuentas (TBA/TBT/TBC)
			if (['TBA', 'TBT', 'TBC'].includes(this.formParrafo.tipo)) {
				if (!Array.isArray(this.formParrafo.cuentas)) {
					this.formParrafo.cuentas = [];
				}

				if (this.formParrafo.cuentas.length === 0) {
					this.$toast.error("Debe seleccionar al menos una cuenta para el tipo " + this.formParrafo.tipo);
					return;
				}
			}

			// Validación para NIIF
			if (['TNA', 'TNT', 'TNC'].includes(this.formParrafo.tipo)) {
				if (!this.formParrafo.niif || this.formParrafo.niif.length === 0) {
					this.$toast.error("Debe seleccionar al menos un NIIF");
					return;
				}
			}

			// Validación para tablas manuales
			if (this.formParrafo.tipo === 'TBM') {
				if (!this.formParrafo.numeroFilas || !this.formParrafo.numeroColumnas) {
					this.$toast.error("Debe especificar número de filas y columnas");
					return;
				}
			}

			// 3. Preparar datos para enviar
			const datosParaEnviar = {
				codReporte: this.dialogReportes,
				numero: this.numero,
				parrafo: this.formParrafo.parrafo,
				tipo: this.formParrafo.tipo,
				titulo: this.formParrafo.titulo,
				orden: this.formParrafo.orden || '1',
				vigencia: this.selVigencia,
				idCompania: this.selCompany,
				idUser: this.$store.state.userId
			};

			// Solo agregar texto para tipos que lo requieren
			if (['TFG', 'TFC', 'TVG', 'TVC'].includes(this.formParrafo.tipo)) {
				let texto_html = '';
				let texto_plano = '';

				if (this.$refs.textEditor && this.$refs.textEditor.getHTML) {
					texto_html = this.$refs.textEditor.getHTML();
				}

				if (this.$refs.textEditor && this.$refs.textEditor.getText) {
					texto_plano = this.$refs.textEditor.getText();
				}

				datosParaEnviar.texto = texto_plano;
				datosParaEnviar.texto_html = texto_html;
			}

			// IMPORTANTE: Para TVC y TFC, se debe enviar idCompania en los datos adicionales
			if (this.formParrafo.tipo === 'TVG' || this.formParrafo.tipo === 'TVC') {
				// Agregar todos los campos valor_campo
				for (let i = 0; i <= 9; i++) {
					datosParaEnviar[`valor_campo${i}`] = this.formParrafo[`valor_campo${i}`] || '';
				}

				if (this.formParrafo.tipo === 'TVC') {
					datosParaEnviar.idCompania = this.selCompany;
				}
			}

			// ENVIAR CUENTAS COMO ARRAY DE STRINGS
			if (['TBA', 'TBT', 'TBC'].includes(this.formParrafo.tipo)) {
				datosParaEnviar.cuentas = this.formParrafo.cuentas
					.map(cuenta => {
						if (cuenta && typeof cuenta === 'object' && cuenta.cuenta) {
							return cuenta.cuenta.toString().trim();
						}
						return cuenta ? cuenta.toString().trim() : '';
					})
					.filter(cuenta => cuenta !== '');
			}

			// ENVIAR NIIF COMO ARRAY
			if (['TNA', 'TNT', 'TNC'].includes(this.formParrafo.tipo)) {
				datosParaEnviar.niif = Array.isArray(this.formParrafo.niif)
					? this.formParrafo.niif
					: [];
			}

			// ENVIAR DATOS DE TABLA
			if (this.formParrafo.tipo === 'TBM') {
				datosParaEnviar.numeroFilas = this.formParrafo.numeroFilas;
				datosParaEnviar.numeroColumnas = this.formParrafo.numeroColumnas;
				datosParaEnviar.filas = this.formParrafo.filas || [];
				datosParaEnviar.columnas = this.formParrafo.columnas || [];
			}

			// Debug: Verificar que idCompania se está enviando para TVC
			console.log('=== ENVIANDO DATOS PARA TVC ===');
			console.log('Tipo:', this.formParrafo.tipo);
			console.log('idCompania en datosParaEnviar:', datosParaEnviar.idCompania);
			console.log('selCompany (valor seleccionado):', this.selCompany);
			console.log('================================');

			// 4. Llamar API
			Notas.createParrafo(datosParaEnviar)
				.then((response) => {
					console.log('Respuesta del servidor:', response.data);
					this.$toast.success("Párrafo Creado");

					// Cerrar diálogos
					this.showParrafo = false;
					this.showCuentas = false;
					this.showNiif = false;
					this.showDialog = false;

					// Recargar datos
					return Balance.getNotas(this.dialogReportes, this.selCompany, this.selVigencia, this.numero);
				})
				.then((result) => {
					// Actualizar datos locales
					if (result && result.data) {
						this.a_detalle = result.data.a_detalle;
						this.a_detalle_texto = result.data.a_detalle_texto;
						this.a_informacion_txfg = result.data.a_informacion_txfg;
						this.a_informacion_txfc = result.data.a_informacion_txfc;
						this.a_informacion_txvg = result.data.a_informacion_txvg;
						this.a_informacion_txvc = result.data.a_informacion_txvc;
						this.a_informacion_tblm = result.data.a_informacion_tblm;

						// Actualizar datos adicionales
						this.a_detalle_cuentas = result.data.a_detalle_cuentas || [];
						this.a_detalle_niif = result.data.a_detalle_niif || [];
						this.a_detalle_filas = result.data.a_detalle_filas || [];
						this.a_detalle_columnas = result.data.a_detalle_columnas || [];
						this.a_detalle_tabla = result.data.a_detalle_tabla || [];
					}

					// Mostrar detalle de nota
					setTimeout(() => {
						this.showNotaDetalle = true;
					}, 100);
				})
				.catch((error) => {
					console.error('Error al crear párrafo:', error);
					console.error('Respuesta del error:', error.response?.data);

					let errorMessage = "Error al crear el Párrafo";
					if (error.response?.data?.message) {
						errorMessage += ": " + error.response.data.message;
					} else if (error.message) {
						errorMessage += ": " + error.message;
					}

					this.$toast.error(errorMessage);
				});
		},
		modificaParrafo() {
			// 1. Obtener el contenido actual del editor
			let texto_html = '';
			let texto_plano = '';

			if (this.$refs.textEditor && this.$refs.textEditor.getHTML) {
				texto_html = this.$refs.textEditor.getHTML();
			}

			if (this.$refs.textEditor && this.$refs.textEditor.getText) {
				texto_plano = this.$refs.textEditor.getText();
			}

			// 2. Validaciones específicas según tipo
			if (['TFG', 'TFC', 'TVG', 'TVC'].includes(this.formParrafo.tipo)) {
				if (!texto_plano || texto_plano.trim() === '') {
					this.$toast.error("El texto no puede estar vacío para este tipo de párrafo");
					return;
				}
			}

			if (['TBA', 'TBT', 'TBC'].includes(this.formParrafo.tipo)) {
				if (!this.formParrafo.cuentas || this.formParrafo.cuentas.length === 0) {
					this.$toast.error("Debe seleccionar al menos una cuenta");
					return;
				}
			}

			if (['TNA', 'TNT', 'TNC'].includes(this.formParrafo.tipo)) {
				if (!this.formParrafo.niif || this.formParrafo.niif.length === 0) {
					this.$toast.error("Debe seleccionar al menos un NIIF");
					return;
				}
			}

			if (this.formParrafo.tipo === 'TBM') {
				if (!this.formParrafo.numeroFilas || !this.formParrafo.numeroColumnas) {
					this.$toast.error("Debe especificar número de filas y columnas");
					return;
				}
			}

			// 3. Preparar datos completos para enviar
			const datosParaEnviar = {
				id: this.formParrafo.id,
				codReporte: this.dialogReportes,
				numero: this.numero,
				parrafo: this.formParrafo.parrafo,
				tipo: this.formParrafo.tipo,
				titulo: this.formParrafo.titulo || '',
				orden: this.formParrafo.orden || '',
				texto: texto_plano,
				texto_html: texto_html,
				vigencia: this.selVigencia,
				idCompania: this.selCompany,
				idUser: this.$store.state.userId,

				// Campos adicionales según el tipo
				...(this.formParrafo.tipo === 'TVG' || this.formParrafo.tipo === 'TVC') && {
					valor_campo0: this.formParrafo.valor_campo0,
					valor_campo1: this.formParrafo.valor_campo1,
					valor_campo2: this.formParrafo.valor_campo2,
					valor_campo3: this.formParrafo.valor_campo3,
					valor_campo4: this.formParrafo.valor_campo4,
					valor_campo5: this.formParrafo.valor_campo5,
					valor_campo6: this.formParrafo.valor_campo6,
					valor_campo7: this.formParrafo.valor_campo7,
					valor_campo8: this.formParrafo.valor_campo8,
					valor_campo9: this.formParrafo.valor_campo9
				},

				...(this.formParrafo.tipo === 'TBM') && {
					numeroFilas: this.formParrafo.numeroFilas,
					numeroColumnas: this.formParrafo.numeroColumnas,
					filas: this.formParrafo.filas,
					columnas: this.formParrafo.columnas
				},

				...(this.formParrafo.tipo === 'TNA' || this.formParrafo.tipo === 'TNT' || this.formParrafo.tipo === 'TNC') && {
					niif: this.formParrafo.niif
				},

				...(this.formParrafo.tipo === 'TBA' || this.formParrafo.tipo === 'TBT' || this.formParrafo.tipo === 'TBC') && {
					cuentas: this.formParrafo.cuentas
				}
			};

			// 4. DEBUG: Ver qué datos se están enviando
			console.log('Modificando párrafo - Datos a enviar:', datosParaEnviar);

			// 5. Llamar al servicio con los datos correctos
			Notas.updateParrafo(datosParaEnviar)
				.then((response) => {
					this.$toast.success(response.data.message || "Párrafo Modificado");

					// 6. Actualizar la caché local - CORREGIDO: Usar bloques {} en cada case
					if (this.cachedNotaData) {
						// Encontrar y actualizar el párrafo en los arrays de cache
						switch (this.formParrafo.tipo) {
							case 'TFG': {
								const txfgIndex = this.cachedNotaData.a_informacion_txfg.findIndex(tx => tx.parrafo === this.formParrafo.parrafo);
								if (txfgIndex !== -1) {
									this.cachedNotaData.a_informacion_txfg[txfgIndex].texto = texto_plano;
									this.cachedNotaData.a_informacion_txfg[txfgIndex].texto_html = texto_html;
								}
								break;
							}

							case 'TFC': {
								const txfcIndex = this.cachedNotaData.a_informacion_txfc.findIndex(tx => tx.parrafo === this.formParrafo.parrafo);
								if (txfcIndex !== -1) {
									this.cachedNotaData.a_informacion_txfc[txfcIndex].texto = texto_plano;
									this.cachedNotaData.a_informacion_txfc[txfcIndex].texto_html = texto_html;
								}
								break;
							}

							case 'TVG':
							case 'TVC': {
								const textoIndex = this.cachedNotaData.a_detalle_texto.findIndex(tx => tx.parrafo === this.formParrafo.parrafo);
								if (textoIndex !== -1) {
									this.cachedNotaData.a_detalle_texto[textoIndex].texto = texto_plano;
									this.cachedNotaData.a_detalle_texto[textoIndex].texto_html = texto_html;
								}
								break;
							}
						}
					}

					// 7. Cerrar diálogos
					this.showDialog = false;
					this.showParrafo = false;

					// 8. Recargar datos del backend para asegurar consistencia
					return Balance.getNotas(this.dialogReportes, this.selCompany, this.selVigencia, this.numero);
				})
				.then((result) => {
					if (result && result.data) {
						// Actualizar todos los arrays con los datos frescos
						this.a_detalle = result.data.a_detalle;
						this.a_detalle_texto = result.data.a_detalle_texto;
						this.a_informacion_txfg = result.data.a_informacion_txfg;
						this.a_informacion_txfc = result.data.a_informacion_txfc;
						this.a_informacion_txvg = result.data.a_informacion_txvg;
						this.a_informacion_txvc = result.data.a_informacion_txvc;
						this.a_informacion_tblm = result.data.a_informacion_tblm;

						// Actualizar la caché
						this.cachedNotaData = {
							a_detalle: result.data.a_detalle,
							a_detalle_texto: result.data.a_detalle_texto,
							a_informacion_txfg: result.data.a_informacion_txfg,
							a_informacion_txfc: result.data.a_informacion_txfc,
							a_informacion_txvg: result.data.a_informacion_txvg,
							a_informacion_txvc: result.data.a_informacion_txvc,
							a_informacion_tblm: result.data.a_informacion_tblm
						};
					}

					// Mostrar el detalle nuevamente
					this.showNotaDetalle = true;
				})
				.catch((error) => {
					console.error('Error al modificar párrafo:', error);

					// Mostrar mensaje de error específico si está disponible
					if (error.response && error.response.data && error.response.data.message) {
						this.$toast.error(`Error: ${error.response.data.message}`);
					} else {
						this.$toast.error("Error al modificar el Párrafo");
					}
				});
		},
		filterCuentasList() {
			if (!this.cuentasSearchTerm) {
				this.filteredCuentasList = [...this.listCuentas];
			} else {
				const term = this.cuentasSearchTerm.toLowerCase();
				this.filteredCuentasList = this.listCuentas.filter(cuenta =>
					(cuenta.cuenta && cuenta.cuenta.toString().toLowerCase().includes(term)) ||
					(cuenta.descripcion && cuenta.descripcion.toLowerCase().includes(term))
				);
			}
			this.updateSelectAllCuentas();
		},

		toggleSelectAllCuentas() {
			if (!this.selectAllCuentas) {
				// Seleccionar todas las cuentas filtradas
				this.filteredCuentasList.forEach(cuenta => {
					if (!this.formParrafo.cuentas.includes(cuenta.cuenta)) {
						this.formParrafo.cuentas.push(cuenta.cuenta);
					}
				});
				this.selectAllCuentas = true;
			} else {
				// Deseleccionar todas las cuentas filtradas
				this.formParrafo.cuentas = this.formParrafo.cuentas.filter(cuentaId =>
					!this.filteredCuentasList.some(c => c.cuenta === cuentaId)
				);
				this.selectAllCuentas = false;
			}
		},

		elimineParrafo() {
			// 1. Validar que tenemos todos los valores
			if (!this.dialogReportes || !this.numero || !this.formParrafo.parrafo || !this.selVigencia) {
				this.$toast.error("Faltan datos para eliminar el párrafo");
				return;
			}

			// 2. Mostrar confirmación
			if (!confirm(`¿Está seguro de eliminar el párrafo ${this.formParrafo.parrafo}?`)) {
				return;
			}

			// 3. Llamar al servicio
			Notas.deleteParrafo(
				this.dialogReportes,
				this.numero,
				this.formParrafo.parrafo,
				this.selVigencia,
				this.selCompany
			)
				.then(() => {
					this.$toast.success("Párrafo Eliminado");

					// 4. Cerrar diálogos
					this.showDialog = false;
					this.showParrafo = false;
					this.showNotaDetalle = false;

					// 5. Recargar los datos de la nota actual (igual que después de modificar)
					return Balance.getNotas(this.dialogReportes, this.selCompany, this.selVigencia, this.numero);
				})
				.then((result) => {
					if (result && result.data) {
						// 6. Actualizar todos los arrays con los datos frescos
						this.a_detalle = result.data.a_detalle;
						this.a_detalle_texto = result.data.a_detalle_texto;
						this.a_informacion_txfg = result.data.a_informacion_txfg;
						this.a_informacion_txfc = result.data.a_informacion_txfc;
						this.a_informacion_txvg = result.data.a_informacion_txvg;
						this.a_informacion_txvc = result.data.a_informacion_txvc;
						this.a_informacion_tblm = result.data.a_informacion_tblm;

						// 7. Actualizar la caché
						this.cachedNotaData = {
							a_detalle: result.data.a_detalle,
							a_detalle_texto: result.data.a_detalle_texto,
							a_informacion_txfg: result.data.a_informacion_txfg,
							a_informacion_txfc: result.data.a_informacion_txfc,
							a_informacion_txvg: result.data.a_informacion_txvg,
							a_informacion_txvc: result.data.a_informacion_txvc,
							a_informacion_tblm: result.data.a_informacion_tblm
						};

						// 8. Mostrar el detalle de la nota nuevamente (igual que el botón "Definición")
						this.showNotaDetalle = true;

						// 9. Resetear el formulario
						this.formParrafo = {
							id: null,
							numero: null,
							parrafo: null,
							tipo: null,
							titulo: '',
							texto: '',
							texto_html: '',
							numeroFilas: '',
							numeroColumnas: '',
							filas: [],
							columnas: [],
							cuentas: [],
							niif: []
						};
					}
				})
				.catch((error) => {
					console.error('Error al eliminar párrafo:', error);
					this.$toast.error("Error al eliminar el Párrafo: " + (error.response?.data?.message || error.message));
				});
		},
		async f_actualiza_nota(item) {
			try {
				// 1. Resetear y preparar formulario
				this.formParrafo = {
					id: null,
					numero: null,
					parrafo: null,
					tipo: null,
					titulo: '',
					texto: '',
					texto_html: '',
					numeroFilas: '',
					numeroColumnas: '',
					filas: [],
					columnas: [],
					cuentas: [],
					niif: []
				};

				// 2. Llenar datos básicos del párrafo seleccionado
				this.formParrafo.id = item.id;
				this.formParrafo.numero = item.numero;
				this.formParrafo.parrafo = item.parrafo;
				this.formParrafo.tipo = item.tipo;
				this.formParrafo.titulo = item.titulo || '';
				this.formParrafo.orden = item.orden || '';

				// 2.1. Si el tipo es TBA/TBT/TBC, cargar cuentas seleccionadas
				if (item.tipo === 'TBA' || item.tipo === 'TBT' || item.tipo === 'TBC') {
					// Buscar cuentas en los datos existentes
					const cuentasExistentes = this.a_detalle_cuentas
						.filter(c => c.parrafo === item.parrafo)
						.map(c => c.cuenta);

					console.log('Cuentas existentes para párrafo:', item.parrafo, cuentasExistentes);
					this.formParrafo.cuentas = cuentasExistentes;
				}

				// 2.2. Si el tipo es TNA/TNT/TNC, cargar NIIFs seleccionados
				if (item.tipo === 'TNA' || item.tipo === 'TNT' || item.tipo === 'TNC') {
					// Buscar NIIFs en los datos existentes
					const niifExistentes = this.a_detalle_niif
						.filter(n => n.parrafo === item.parrafo)
						.map(n => n.niif);

					console.log('NIIFs existentes para párrafo:', item.parrafo, niifExistentes);
					this.formParrafo.niif = niifExistentes;
				}

				// 2.3. Si el tipo es TBM, cargar datos de tabla
				if (item.tipo === 'TBM') {
					// Buscar datos de tabla
					const tablaData = this.a_detalle_tabla.find(t => t.parrafo === item.parrafo);
					if (tablaData) {
						this.formParrafo.numeroFilas = tablaData.filas;
						this.formParrafo.numeroColumnas = tablaData.columnas;

						// Cargar filas
						const filasData = this.a_detalle_filas.filter(f => f.parrafo === item.parrafo);
						this.formParrafo.filas = filasData.map(f => ({
							fila: f.fila,
							descripcion: f.descripcion,
							d_fila: `Fila ${f.fila}`
						}));

						// Cargar columnas
						const columnasData = this.a_detalle_columnas.filter(c => c.parrafo === item.parrafo);
						this.formParrafo.columnas = columnasData.map(c => ({
							columna: c.columna,
							descripcion: c.descripcion,
							d_columna: `Columna ${c.columna}`
						}));
					}
				}

				// 3. Cargar texto según el tipo - SIN DUPLICAR EN CACHE/LOCAL
				let textoEncontrado = '';
				let textoHtmlEncontrado = '';

				// Buscar primero en cache local (pero NO agregar si no existe)
				if (this.cachedNotaData) {
					switch (item.tipo) {
						case 'TFG': {
							const txfgCache = this.cachedNotaData.a_informacion_txfg.find(
								tx => tx.parrafo === item.parrafo
							);
							if (txfgCache) {
								textoEncontrado = txfgCache.texto || '';
								textoHtmlEncontrado = txfgCache.texto_html || '';
							}
							break;
						}

						case 'TFC': {
							const txfcCache = this.cachedNotaData.a_informacion_txfc.find(
								tx => tx.parrafo === item.parrafo
							);
							if (txfcCache) {
								textoEncontrado = txfcCache.texto || '';
								textoHtmlEncontrado = txfcCache.texto_html || '';
							}
							break;
						}

						case 'TVG': {
							const txvgTextCache = this.cachedNotaData.a_detalle_texto.find(
								tx => tx.parrafo === item.parrafo
							);
							if (txvgTextCache) {
								textoEncontrado = txvgTextCache.texto || '';
								textoHtmlEncontrado = txvgTextCache.texto_html || '';
							}
							break;
						}

						case 'TVC': {
							const txvcTextCache = this.cachedNotaData.a_detalle_texto.find(
								tx => tx.parrafo === item.parrafo
							);
							if (txvcTextCache) {
								textoEncontrado = txvcTextCache.texto || '';
								textoHtmlEncontrado = txvcTextCache.texto_html || '';
							}
							break;
						}
					}
				}

				// Si no se encontró en cache, buscar en arrays locales (SIN AGREGAR)
				if (!textoEncontrado) {
					switch (item.tipo) {
						case 'TFG': {
							const txfgLocal = this.a_informacion_txfg.find(
								tx => tx.parrafo === item.parrafo
							);
							if (txfgLocal) {
								textoEncontrado = txfgLocal.texto || '';
								textoHtmlEncontrado = txfgLocal.texto_html || '';
							}
							break;
						}

						case 'TFC': {
							const txfcLocal = this.a_informacion_txfc.find(
								tx => tx.parrafo === item.parrafo
							);
							if (txfcLocal) {
								textoEncontrado = txfcLocal.texto || '';
								textoHtmlEncontrado = txfcLocal.texto_html || '';
							}
							break;
						}

						case 'TVG': {
							const txvgTextLocal = this.a_detalle_texto.find(
								tx => tx.parrafo === item.parrafo
							);
							if (txvgTextLocal) {
								textoEncontrado = txvgTextLocal.texto || '';
								textoHtmlEncontrado = txvgTextLocal.texto_html || '';
							}
							break;
						}

						case 'TVC': {
							const txvcTextLocal = this.a_detalle_texto.find(
								tx => tx.parrafo === item.parrafo
							);
							if (txvcTextLocal) {
								textoEncontrado = txvcTextLocal.texto || '';
								textoHtmlEncontrado = txvcTextLocal.texto_html || '';
							}
							break;
						}
					}
				}

				// Asignar los valores encontrados (o vacíos si no se encontró nada)
				if (textoHtmlEncontrado.length == 0) {
					textoHtmlEncontrado = textoEncontrado
				}
				this.formParrafo.texto = textoEncontrado;
				this.formParrafo.texto_html = textoHtmlEncontrado;

				// 4. Configurar campos según tipo
				this.f_pide_campo();

				// 5. Mostrar el diálogo de edición
				this.showDialog = true;
				this.showNotaDetalle = false;
				this.showParrafo = false;

				// 6. Forzar actualización del editor
				this.$nextTick(() => {
					if (this.$refs.textEditor && this.$refs.textEditor.setHTML) {
						this.$refs.textEditor.setHTML(this.formParrafo.texto_html || '');
					}
				});

			} catch (error) {
				console.error('Error en f_actualiza_nota:', error);
				this.$toast.error('Error al cargar el párrafo');
			}
		},
		filterNiifList() {
			if (!this.niifSearchTerm) {
				this.filteredNiifList = [...this.listNiif];
			} else {
				const term = this.niifSearchTerm.toLowerCase();
				this.filteredNiifList = this.listNiif.filter(niif =>
					(niif.niif && niif.niif.toString().toLowerCase().includes(term)) ||
					(niif.nameNiif && niif.nameNiif.toLowerCase().includes(term))
				);
			}
			this.updateSelectAllNiif();
		},

		toggleSelectAllNiif() {
			if (!this.selectAllNiif) {
				// Seleccionar todos los NIIF filtrados
				this.filteredNiifList.forEach(niif => {
					if (!this.formParrafo.niif.includes(niif.niif)) {
						this.formParrafo.niif.push(niif.niif);
					}
				});
				this.selectAllNiif = true;
			} else {
				// Deseleccionar todos los NIIF filtrados
				this.formParrafo.niif = this.formParrafo.niif.filter(niifId =>
					!this.filteredNiifList.some(n => n.niif === niifId)
				);
				this.selectAllNiif = false;
			}
		},

		updateSelectAllNiif() {
			if (this.filteredNiifList.length === 0) {
				this.selectAllNiif = false;
				return;
			}
			this.selectAllNiif = this.filteredNiifList.every(niif =>
				this.formParrafo.niif.includes(niif.niif)
			);
		},

		isCuentaSelected(cuentaId) {
			return this.formParrafo.cuentas.includes(cuentaId);
		},

		toggleCuentaSelection(cuentaId) {
			const index = this.formParrafo.cuentas.indexOf(cuentaId);
			if (index > -1) {
				this.formParrafo.cuentas.splice(index, 1);
			} else {
				this.formParrafo.cuentas.push(cuentaId);
			}
			this.updateSelectAllCuentas();
		},


		updateSelectAllCuentas() {
			if (this.filteredCuentasList.length === 0) {
				this.selectAllCuentas = false;
				return;
			}
			this.selectAllCuentas = this.filteredCuentasList.every(cuenta =>
				this.formParrafo.cuentas.includes(cuenta.cuenta)
			);
		},
		f_actualiza_forma() {
			this.f_pide_campo();

			if (this.formAnterior.tipo == "TFG") {
				const txfg = this.a_informacion_txfg.filter((parrafo) =>
					parrafo.parrafo != this.formAnterior.parrafo)
				if (txfg) {
					this.a_informacion_txfg = txfg
				} else {
					this.a_informacion_txfg = []
				}
			}
			if (this.formAnterior.tipo == "TFC") {
				const txfc = this.a_informacion_txfc.filter((parrafo) =>
					parrafo.parrafo != this.formAnterior.parrafo)
				if (txfc) {
					this.a_informacion_txfc = txfc
				} else {
					this.a_informacion_txfc = []
				}
			}
			if (this.formAnterior.tipo == "TVG") {
				const txvg = this.a_informacion_txvg.filter((parrafo) =>
					parrafo.parrafo != this.formParrafo.parrafo)
				if (txvg) {
					this.a_informacion_txvg = txvg
				} else {
					this.a_informacion_txvg = []
				}
				const txvgd = this.a_detalle_texto.filter((parrafo) =>
					parrafo.parrafo != this.formParrafo.parrafo)
				if (txvgd) {
					this.a_detalle_texto = txvgd
				} else {
					this.a_detalle_texto = []
				}
				this.formParrafo.valor_campo0 = null
				this.formParrafo.valor_campo1 = null
				this.formParrafo.valor_campo2 = null
				this.formParrafo.valor_campo3 = null
				this.formParrafo.valor_campo4 = null
				this.formParrafo.valor_campo5 = null
				this.formParrafo.valor_campo6 = null
				this.formParrafo.valor_campo7 = null
				this.formParrafo.valor_campo8 = null
				this.formParrafo.valor_campo9 = null
				this.formParrafo.campo0 = null
				this.formParrafo.campo1 = null
				this.formParrafo.campo2 = null
				this.formParrafo.campo3 = null
				this.formParrafo.campo4 = null
				this.formParrafo.campo5 = null
				this.formParrafo.campo6 = null
				this.formParrafo.campo7 = null
				this.formParrafo.campo8 = null
				this.formParrafo.campo9 = null
			}
			if (this.formAnterior.tipo == "TVC") {
				const txvc = this.a_informacion_txvc.filter((parrafo) =>
					parrafo.parrafo != this.formParrafo.parrafo)
				if (txvc) {
					this.a_informacion_txvc = txvc
				} else {
					this.a_informacion_txvc = []
				}
				const txvgd = this.a_detalle_texto.filter((parrafo) =>
					parrafo.parrafo != this.formParrafo.parrafo)
				if (txvgd) {
					this.a_detalle_texto = txvgd
				} else {
					this.a_detalle_texto = []
				}
				this.formParrafo.valor_campo0 = null
				this.formParrafo.valor_campo1 = null
				this.formParrafo.valor_campo2 = null
				this.formParrafo.valor_campo3 = null
				this.formParrafo.valor_campo4 = null
				this.formParrafo.valor_campo5 = null
				this.formParrafo.valor_campo6 = null
				this.formParrafo.valor_campo7 = null
				this.formParrafo.valor_campo8 = null
				this.formParrafo.valor_campo9 = null
				this.formParrafo.campo0 = null
				this.formParrafo.campo1 = null
				this.formParrafo.campo2 = null
				this.formParrafo.campo3 = null
				this.formParrafo.campo4 = null
				this.formParrafo.campo5 = null
				this.formParrafo.campo6 = null
				this.formParrafo.campo7 = null
				this.formParrafo.campo8 = null
				this.formParrafo.campo9 = null
			}
			if (this.formAnterior.tipo == "TBM") {
				this.formParrafo.numeroFilas = ""
				this.formParrafo.numeroColumnas = ""
				this.showFila0 = false
				this.showFila1 = false
				this.showFila2 = false
				this.showFila3 = false
				this.showFila4 = false
				this.showFila5 = false
				this.showFila6 = false
				this.showFila7 = false
				this.showFila8 = false
				this.showFila9 = false
				this.showColumna0 = false
				this.showColumna1 = false
				this.showColumna2 = false
				this.showColumna3 = false
				this.showColumna4 = false
				this.showColumna5 = false
				this.showColumna6 = false
				this.showColumna7 = false
				this.showColumna8 = false
				this.showColumna9 = false
			}
			if (this.formParrafo.tipo == "TFG") {
				const r_txfg = {
					id: 0,
					numero: this.formParrafo.numero,
					parrafo: this.formParrafo.parrafo,
					vigencia: this.formParrafo.vigencia,
					texto: this.formParrafo.texto,
					u_crea: this.formParrafo.u_crea,
					createdAt: this.formParrafo.createdAt,
					u_modifica: 2,
					uspdatedAt: this.formParrafo.createdAt,
				}
				this.a_informacion_txfg.push(r_txfg)
			}
			if (this.formParrafo.tipo == "TFC") {
				const r_txfc = {
					id: 0,
					numero: this.formParrafo.numero,
					parrafo: this.formParrafo.parrafo,
					vigencia: this.formParrafo.vigencia,
					id_compania: this.selCompany,
					texto: this.formParrafo.texto,
					u_crea: this.formParrafo.u_crea,
					createdAt: this.formParrafo.createdAt,
					u_modifica: 2,
					uspdatedAt: this.formParrafo.createdAt,
				}
				this.a_informacion_txfc.push(r_txfc)
			}
			if (this.formParrafo.tipo == "TVG" || this.formParrafo.tipo == "TVC") {
				const rd_txvc = {
					id: 0,
					numero: this.formParrafo.numero,
					parrafo: this.formParrafo.parrafo,
					vigencia: this.formParrafo.vigencia,
					texto: this.formParrafo.texto,
					campo0: null,
					campo1: null,
					campo2: null,
					campo3: null,
					campo4: null,
					campo5: null,
					campo6: null,
					campo7: null,
					campo8: null,
					campo9: null,
					u_crea: this.formParrafo.u_crea,
					createdAt: this.formParrafo.createdAt,
					u_modifica: 2,
					uspdatedAt: this.formParrafo.createdAt,
				}
				this.a_detalle_texto.push(rd_txvc)
				if (this.formParrafo.tipo == "TVG") {
					const ri_txvg = {
						id: 0,
						numero: this.formParrafo.numero,
						parrafo: this.formParrafo.parrafo,
						vigencia: this.formParrafo.vigencia,
						valor_campo0: null,
						valor_campo1: null,
						valor_campo2: null,
						valor_campo3: null,
						valor_campo4: null,
						valor_campo5: null,
						valor_campo6: null,
						valor_campo7: null,
						valor_campo8: null,
						valor_campo9: null,
						u_crea: this.formParrafo.u_crea,
						createdAt: this.formParrafo.createdAt,
						u_modifica: 2,
						uspdatedAt: this.formParrafo.createdAt,
					}
					this.a_informacion_txvg.push(ri_txvg)
				}
				if (this.formParrafo.tipo == "TVC") {
					const ri_txvc = {
						id: 0,
						numero: this.formParrafo.numero,
						parrafo: this.formParrafo.parrafo,
						vigencia: this.formParrafo.vigencia,
						id_compania: this.selCompany,
						valor_campo0: null,
						valor_campo1: null,
						valor_campo2: null,
						valor_campo3: null,
						valor_campo4: null,
						valor_campo5: null,
						valor_campo6: null,
						valor_campo7: null,
						valor_campo8: null,
						valor_campo9: null,
						u_crea: this.formParrafo.u_crea,
						createdAt: this.formParrafo.createdAt,
						u_modifica: 2,
						uspdatedAt: this.formParrafo.createdAt,
					}
					this.a_informacion_txvc.push(ri_txvc)
				}
			}
			if (this.formParrafo.tipo == "TFG") {
				const txfg = this.a_informacion_txfg.find((parrafo) =>
					parrafo.parrafo == this.formParrafo.parrafo)
				if (txfg) {
					this.formParrafo.texto = txfg.texto
				}
			}
			if (this.formParrafo.tipo == "TFC") {
				const txfc = this.a_informacion_txfc.find((parrafo) =>
					parrafo.parrafo == this.formParrafo.parrafo)
				if (txfc) {
					this.formParrafo.texto = txfc.texto
				}
			}
			if (this.formParrafo.tipo == "TVG") {
				const txvg = this.a_informacion_txvg.find((parrafo) =>
					parrafo.parrafo == this.formParrafo.parrafo)
				if (txvg) {
					let txvgd = this.a_detalle_texto.find((txvg) =>
						txvg.parrafo == this.formParrafo.parrafo
					)
					const dt = this.a_detalle_texto.find((variable) =>
						variable.parrafo == this.formParrafo.parrafo)
					this.formParrafo.texto = txvgd.texto
					this.formParrafo.valor_campo0 = dt.campo0
					this.formParrafo.valor_campo1 = dt.campo1
					this.formParrafo.valor_campo2 = dt.campo2
					this.formParrafo.valor_campo3 = dt.campo3
					this.formParrafo.valor_campo4 = dt.campo4
					this.formParrafo.valor_campo5 = dt.campo5
					this.formParrafo.valor_campo6 = dt.campo6
					this.formParrafo.valor_campo7 = dt.campo7
					this.formParrafo.valor_campo8 = dt.campo8
					this.formParrafo.valor_campo9 = dt.campo9
					this.formParrafo.campo0 = "Campo 0"
					this.formParrafo.campo1 = "Campo 1"
					this.formParrafo.campo2 = "Campo 2"
					this.formParrafo.campo3 = "Campo 3"
					this.formParrafo.campo4 = "Campo 4"
					this.formParrafo.campo5 = "Campo 5"
					this.formParrafo.campo6 = "Campo 6"
					this.formParrafo.campo7 = "Campo 7"
					this.formParrafo.campo8 = "Campo 8"
					this.formParrafo.campo9 = "Campo 9"
				}
			}
			if (this.formParrafo.tipo == "TVC") {
				const txvc = this.a_informacion_txvc.find((parrafo) =>
					parrafo.parrafo == this.formParrafo.parrafo)
				if (txvc) {
					let txvgd = this.a_detalle_texto.find((txvg) =>
						txvg.parrafo == this.formParrafo.parrafo
					)
					const dt = this.a_detalle_texto.find((variable) =>
						variable.parrafo == this.formParrafo.parrafo)
					this.formParrafo.texto = txvgd.texto
					this.formParrafo.valor_campo0 = dt.campo0
					this.formParrafo.valor_campo1 = dt.campo1
					this.formParrafo.valor_campo2 = dt.campo2
					this.formParrafo.valor_campo3 = dt.campo3
					this.formParrafo.valor_campo4 = dt.campo4
					this.formParrafo.valor_campo5 = dt.campo5
					this.formParrafo.valor_campo6 = dt.campo6
					this.formParrafo.valor_campo7 = dt.campo7
					this.formParrafo.valor_campo8 = dt.campo8
					this.formParrafo.valor_campo9 = dt.campo9
					this.formParrafo.campo0 = "Campo 0"
					this.formParrafo.campo1 = "Campo 1"
					this.formParrafo.campo2 = "Campo 2"
					this.formParrafo.campo3 = "Campo 3"
					this.formParrafo.campo4 = "Campo 4"
					this.formParrafo.campo5 = "Campo 5"
					this.formParrafo.campo6 = "Campo 6"
					this.formParrafo.campo7 = "Campo 7"
					this.formParrafo.campo8 = "Campo 8"
					this.formParrafo.campo9 = "Campo 9"
				}
			}
			if (this.formParrafo.tipo == "TBM") {
				this.formParrafo.nroFilas = "Numero de Filas"
				this.formParrafo.nroColumnas = "Numero de Columnas"
			}
			if (this.formParrafo.tipo != "TBM") {
				this.formParrafo.nroFilas = ""
				this.formParrafo.nroColumnas = ""
				this.showFila0 = false
				this.showFila1 = false
				this.showFila2 = false
				this.showFila3 = false
				this.showFila4 = false
				this.showFila5 = false
				this.showFila6 = false
				this.showFila7 = false
				this.showFila8 = false
				this.showFila9 = false
				this.showColumna0 = false
				this.showColumna1 = false
				this.showColumna2 = false
				this.showColumna3 = false
				this.showColumna4 = false
				this.showColumna5 = false
				this.showColumna6 = false
				this.showColumna7 = false
				this.showColumna8 = false
				this.showColumna9 = false
			}
			
		},

		f_cambia_texto() {

			const textoPlano = this.formParrafo.texto

			if (this.formParrafo.tipo == "TFG") {
				const v_idx = this.a_informacion_txfg.findIndex((texto) =>
					texto.parrafo == this.formParrafo.parrafo
				)
				if (v_idx >= 0) {
					this.a_informacion_txfg[v_idx].texto = textoPlano
					if (!this.a_informacion_txfg[v_idx].texto_html) {
						this.a_informacion_txfg[v_idx].texto_html = this.plainTextToHTML(textoPlano)
					}
				}
			}
			if (this.formParrafo.tipo == "TFC") {
				const v_idx = this.a_informacion_txfc.findIndex((texto) =>
					texto.parrafo == this.formParrafo.parrafo
				)
				this.a_informacion_txfc[v_idx].texto = this.formParrafo.texto
			}
			if (this.formParrafo.tipo == "TVG" || this.formParrafo.tipo == "TVC") {
				const v_idx = this.a_detalle_texto.findIndex((texto) =>
					texto.parrafo == this.formParrafo.parrafo
				)
				this.a_detalle_texto[v_idx].texto = this.formParrafo.texto
			}
		},

		plainTextToHTML(text) {
			if (!text) return ''

			// Convertir saltos de línea a párrafos
			const paragraphs = text.split('\n').filter(p => p.trim())

			if (paragraphs.length === 0) return ''
			if (paragraphs.length === 1) return `<p>${this.escapeHTML(paragraphs[0])}</p>`

			return paragraphs.map(p => `<p>${this.escapeHTML(p)}</p>`).join('')
		},

		escapeHTML(text) {
			const div = document.createElement('div')
			div.textContent = text
			return div.innerHTML
		},

		f_cambia_texto_html(html) {
			// Cuando cambia el HTML, también actualizar el texto plano
			this.formParrafo.texto = this.htmlToPlainText(html)

			// Actualizar en los arrays correspondientes
			if (this.formParrafo.tipo == "TFG") {
				const v_idx = this.a_informacion_txfg.findIndex((texto) =>
					texto.parrafo == this.formParrafo.parrafo
				)
				if (v_idx >= 0) {
					this.a_informacion_txfg[v_idx].texto_html = html
					this.a_informacion_txfg[v_idx].texto = this.formParrafo.texto
				}
			}

			if (this.formParrafo.tipo == "TFC") {
				const v_idx = this.a_informacion_txfc.findIndex((texto) =>
					texto.parrafo == this.formParrafo.parrafo
				)
				if (v_idx >= 0) {
					this.a_informacion_txfc[v_idx].texto_html = html
					this.a_informacion_txfc[v_idx].texto = this.formParrafo.texto
				}
			}

			if (this.formParrafo.tipo == "TVG" || this.formParrafo.tipo == "TVC") {
				const v_idx = this.a_detalle_texto.findIndex((texto) =>
					texto.parrafo == this.formParrafo.parrafo
				)
				if (v_idx >= 0) {
					this.a_detalle_texto[v_idx].texto_html = html
					this.a_detalle_texto[v_idx].texto = this.formParrafo.texto
				}
			}
		},

		limpiarDatosNota() {
			// 1. Resetear datos de la nota actual
			this.currentNotaId = null;
			this.nota = "";
			this.numero = "";

			// 2. Resetear arrays de datos por compañía
			this.a_detalle = [];
			this.a_detalle_texto = [];
			this.a_detalle_cuentas = [];
			this.a_detalle_niif = [];
			this.a_detalle_filas = [];
			this.a_detalle_columnas = [];
			this.a_detalle_tabla = [];

			// 3. Resetear arrays de información por tipo
			this.a_informacion_txfg = [];
			this.a_informacion_txfc = [];
			this.a_informacion_txvg = [];
			this.a_informacion_txvc = [];
			this.a_informacion_tblm = [];

			// 4. Resetear la caché (PRINCIPAL CAUSA DEL PROBLEMA)
			this.cachedNotaData = null;

			// 5. Resetear formularios
			this.formParrafo = {
				id: null,
				numero: null,
				parrafo: null,
				tipo: null,
				titulo: '',
				texto: '',
				texto_html: '',
				numeroFilas: '',
				numeroColumnas: '',
				filas: [],
				columnas: [],
				cuentas: [],
				niif: []
			};

			this.formNueva = {
				numero: '',
				descripcion: '',
			};

			// 6. Resetear estados de UI
			this.showNotaDetalle = false;
			this.showDialog = false;
			this.showParrafo = false;
			this.showNuevo = false;
			this.showEdita = false;

			// 7. Resetear filtros de búsqueda
			this.cuentasSearchTerm = '';
			this.niifSearchTerm = '';
			this.selectAllCuentas = false;
			this.selectAllNiif = false;

			// 8. Resetear flags de visualización
			this.showCuentas = false;
			this.showNiif = false;
			this.showTexto = false;
			this.showCampo = false;
			this.showCampoTabla = false;

			// 9. Resetear flags de filas/columnas
			this.showFila0 = this.showFila1 = this.showFila2 = this.showFila3 = this.showFila4 =
				this.showFila5 = this.showFila6 = this.showFila7 = this.showFila8 = this.showFila9 = false;

			this.showColumna0 = this.showColumna1 = this.showColumna2 = this.showColumna3 = this.showColumna4 =
				this.showColumna5 = this.showColumna6 = this.showColumna7 = this.showColumna8 = this.showColumna9 = false;

			console.log('Datos de nota limpiados para cambio de compañía');
		},

		// Función auxiliar para convertir HTML a texto plano
		htmlToPlainText(html) {
			if (!html) return ''

			// Crear elemento temporal
			const tempDiv = document.createElement('div')
			tempDiv.innerHTML = html

			// Obtener texto y limpiar
			let text = tempDiv.textContent || tempDiv.innerText || ''

			// Reemplazar múltiples espacios y saltos de línea
			text = text.replace(/\s+/g, ' ')
				.replace(/\n\s*\n/g, '\n')
				.trim()

			return text
		}, cerrarDialogParrafo() {
			this.showDialog = false;
			this.showParrafo = false;

			// Recargar datos y mostrar el detalle
			if (this.numero && this.selVigencia && this.selCompany) {
				Balance.getNotas(this.dialogReportes, this.selCompany, this.selVigencia, this.numero)
					.then((result) => {
						// Actualizar arrays
						this.a_detalle = result.data.a_detalle;
						this.a_detalle_texto = result.data.a_detalle_texto;
						this.a_informacion_txfg = result.data.a_informacion_txfg;
						this.a_informacion_txfc = result.data.a_informacion_txfc;
						this.a_informacion_txvg = result.data.a_informacion_txvg;
						this.a_informacion_txvc = result.data.a_informacion_txvc;
						this.a_informacion_tblm = result.data.a_informacion_tblm;

						// Actualizar cache
						this.cachedNotaData = {
							a_detalle: result.data.a_detalle,
							a_detalle_texto: result.data.a_detalle_texto,
							a_informacion_txfg: result.data.a_informacion_txfg,
							a_informacion_txfc: result.data.a_informacion_txfc,
							a_informacion_txvg: result.data.a_informacion_txvg,
							a_informacion_txvc: result.data.a_informacion_txvc,
							a_informacion_tblm: result.data.a_informacion_tblm
						};

						// Mostrar el detalle
						this.showNotaDetalle = true;
					})
					.catch((error) => {
						console.error('Error al recargar datos:', error);
						this.showNotaDetalle = true;
					});
			} else {
				this.showNotaDetalle = true;
			}
		},
		f_cambia_campo(campo) {
			const dt = this.a_detalle_texto.findIndex((r_campo) =>
				r_campo.parrafo == this.formParrafo.parrafo)
			if (campo == 0) {
				this.a_detalle_texto[dt].campo0 = this.formParrafo.valor_campo0
			}
			if (campo == 1) {
				this.a_detalle_texto[dt].campo1 = this.formParrafo.valor_campo1
			}
			if (campo == 2) {
				this.a_detalle_texto[dt].campo2 = this.formParrafo.valor_campo2
			}
			if (campo == 3) {
				this.a_detalle_texto[dt].campo3 = this.formParrafo.valor_campo3
			}
			if (campo == 4) {
				this.a_detalle_texto[dt].campo4 = this.formParrafo.valor_campo4
			}
			if (campo == 5) {
				this.a_detalle_texto[dt].campo5 = this.formParrafo.valor_campo5
			}
			if (campo == 6) {
				this.a_detalle_texto[dt].campo6 = this.formParrafo.valor_campo6
			}
			if (campo == 7) {
				this.a_detalle_texto[dt].campo7 = this.formParrafo.valor_campo7
			}
			if (campo == 8) {
				this.a_detalle_texto[dt].campo8 = this.formParrafo.valor_campo8
			}
			if (campo == 9) {
				this.a_detalle_texto[dt].campo9 = this.formParrafo.valor_campo9
			}
		},
		cerrarNotaDetalle() {
			this.showNotaDetalle = false;

			// Recargar los datos de la nota actual
			if (this.numero && this.selVigencia && this.selCompany) {
				Balance.getNotas(this.dialogReportes, this.selCompany, this.selVigencia, this.numero)
					.then((result) => {
						// Actualizar todos los arrays con los nuevos datos
						this.a_detalle = result.data.a_detalle;
						this.a_detalle_texto = result.data.a_detalle_texto;
						this.a_informacion_txfg = result.data.a_informacion_txfg;
						this.a_informacion_txfc = result.data.a_informacion_txfc;
						this.a_informacion_txvg = result.data.a_informacion_txvg;
						this.a_informacion_txvc = result.data.a_informacion_txvc;
						this.a_informacion_tblm = result.data.a_informacion_tblm;

						// Actualizar cache
						this.cachedNotaData = {
							a_detalle: result.data.a_detalle,
							a_detalle_texto: result.data.a_detalle_texto,
							a_informacion_txfg: result.data.a_informacion_txfg,
							a_informacion_txfc: result.data.a_informacion_txfc,
							a_informacion_txvg: result.data.a_informacion_txvg,
							a_informacion_txvc: result.data.a_informacion_txvc,
							a_informacion_tblm: result.data.a_informacion_tblm
						};
					})
					.catch((error) => {
						console.error('Error al recargar datos:', error);
					});
			}
		},
		grabeNota() {

			if (this.formNueva.numero == '' || this.formNueva.descripcion == '') {
				this.$toast.error("Campo(s) pendiente(s) por diligenciar")
			} else {
				let formData = {
					'codReporte': this.dialogReportes,
					'numero': this.formNueva.numero,
					'nota': this.formNueva.descripcion,
					'idUser': this.$store.state.userId
				}
				Notas.createNota(formData)
					.then((res) => {
						// console.log(res.data)
						this.$toast.success(res.data.message)
						this.refrescaTbl()
					})
					.catch((err) => {
						this.$toast.error(err.message)
					})
			}
		},
		actualizaNota() {

			if (this.formNueva.descripcion == '') {
				this.$toast.error("Campo pendiente por diligenciar")
			} else {
				let formData = {
					'id': this.formNueva.id,
					'codReporte': this.dialogReportes,
					'numero': this.formNueva.numero,
					'nota': this.formNueva.descripcion,
					'idUser': this.$store.state.userId
				}
				Notas.updateNota(formData)
					.then((res) => {
						this.$toast.success(res.data.message)
						this.refrescaTbl()
					})
					.catch((err) => {
						this.$toast.error(err.message)
					})
			}
		},
		refrescaTbl() {
			Notas.getAllNotas(this.dialogReportes)
				.then((res) => {
					this.listaNotas = res.data.listNotas
				})
				.catch((err) => {
					console.log(err)
				})
			this.showNuevo = false
			this.showEdita = false
		},
		getCodigoParaNotas(codigoReporte) {
			if (!codigoReporte || !this.reportes.length) return codigoReporte;

			const reporte = this.reportes.find(r => r.codigo == codigoReporte);
			if (!reporte) {
				console.warn('Reporte no encontrado:', codigoReporte);
				return codigoReporte;
			}

			const codigoParaNotas = reporte.libro_notas || codigoReporte;

			if (codigoParaNotas !== codigoReporte) {
				console.log(`Mapeo de reporte: ${codigoReporte} -> ${codigoParaNotas} (libro_notas)`);
			}

			return codigoParaNotas;
		},
		getCodigoParaNiif(codigoReporte) {
			if (!codigoReporte || !this.reportes.length) return codigoReporte;

			const reporte = this.reportes.find(r => r.codigo == codigoReporte);
			return reporte?.libro_notas || codigoReporte;
		},
		f_carga_informacion() {
			this.limpiarDatosNota();

			this.listaNotas = [];

			if (this.dialogReportes > 0) {
				Notas.getAllNotas(this.dialogReportes)
					.then((res) => {
						this.listaNotas = res.data.listNotas;
					})
					.catch((err) => {
						console.log(err);
						this.listaNotas = [];
					});
			}

			if (this.selCompany) {
				this.showDialog = false;
				this.showNotaDetalle = false;
				this.showParrafo = false;
				this.showCuentas = false;
				this.showNiif = false;

				const codigoParaNiif = this.getCodigoParaNiif(this.dialogReportes);

				const codigoParaNotas = this.dialogReportes;

				console.log('Código original seleccionado:', this.dialogReportes);
				console.log('Para NIIF/PlanCons:', codigoParaNiif);
				console.log('Para Notas:', codigoParaNotas);

				if (this.selVigencia && codigoParaNiif) {
					PlanConsolidacion.getPlanConsPorCompVige(this.selVigencia, codigoParaNiif, this.selCompany)
						.then((res) => {
							this.listNiif = res.data.planConsNiif || [];
							this.filteredNiifList = [...this.listNiif];
							this.niifSearchTerm = '';
							this.selectAllNiif = false;
						})
						.catch((error) => {
							console.error('Error al cargar NIIF:', error);
							this.listNiif = [];
							this.filteredNiifList = [];
						});
				}

				if (this.selVigencia) {
					PlanCuentas.planCuentPorCompaVig(this.selCompany, this.selVigencia)
						.then((r_cuentas) => {
							this.listCuentas = r_cuentas.data.planCuentas;
							this.filteredCuentasList = [...this.listCuentas];
							this.cuentasSearchTerm = '';
							this.selectAllCuentas = false;
						})
						.catch((error) => {
							console.error('Error al cargar cuentas:', error);
							this.listCuentas = [];
							this.filteredCuentasList = [];
						});
				}
			} else {
				this.listCuentas = [];
				this.filteredCuentasList = [];
				this.listNiif = [];
				this.filteredNiifList = [];
			}
		}
	},
	mounted() {
		Balance.getReportes()
			.then((result) => {
				this.reportes = Array.isArray(result.data.reportes)
					? result.data.reportes
					: (result.data.reportes[0] || []);

				console.log('Reportes cargados:', this.reportes);
				console.log('¿Tiene libro_notas el reporte 50?',
					this.reportes.find(r => r.codigo == 50)?.libro_notas);
			})
			.catch(() => {
				this.error = true;
			});
		PlanCuentas.getVigenciaPlancuentas()
			.then((res) => {
				this.listVigencia = res.data.getVigencia
			})
			.catch((err) => {
				console.log(err)
			})
			.finally(() => {
				this.isLoading = false;
			})

		PlanCuentas.planCuentPorCompaVig(this.selCompany, this.selVigencia)
			.then((r_cuentas) => {
				this.listCuentas = r_cuentas.data.planCuentas;
				this.filteredCuentasList = [...this.listCuentas];
			})
			.catch((error) => {
				console.error('Error al cargar cuentas:', error);
			});

		this.$nextTick(() => {
			if (this.listCuentas && this.listCuentas.length > 0) {
				this.filteredCuentasList = [...this.listCuentas];
			}
			if (this.listNiif && this.listNiif.length > 0) {
				this.filteredNiifList = [...this.listNiif];
			}
		});

		Company.getAllCompanies()
			.then((result) => {
				this.listCompany = result.data.companies
				this.showSelCompany = true
			})
			.catch((err) => {
				console.log(err)
			})
			.finally(() => {
				this.isLoading = false;
			})
	},
}
</script>